import { css } from '@emotion/react';

export const LayoutStyle = {
  colAC: css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  colACJC: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `,
  gap12: css`
    gap: 12px;
  `,
  gap24: css`
    gap: 24px;
  `,
  flex: css`
    display: flex;
    flex-direction: column;
  `,
  flexGrow: css`
    flex-grow: 1;
  `,
  inlineBlock: css`
    display: inline-block;
  `,
  mb4: css`
    margin-bottom: 4px;
  `,
  mb8: css`
    margin-bottom: 8px;
  `,
  mb12: css`
    margin-bottom: 12px;
  `,
  mb16: css`
    margin-bottom: 16px;
  `,
  mb24: css`
    margin-bottom: 24px;
  `,
  mb40: css`
    margin-bottom: 40px;
  `,
  mb48: css`
    margin-bottom: 48px;
  `,
  mb64: css`
    margin-bottom: 64px;
  `,
  ml4: css`
    margin-left: 4px;
  `,
  ml8: css`
    margin-left: 8px;
  `,
  ml12: css`
    margin-left: 12px;
  `,
  ml16: css`
    margin-left: 16px;
  `,
  ml24: css`
    margin-left: 24px;
  `,
  mr4: css`
    margin-right: 4px;
  `,
  mr8: css`
    margin-right: 8px;
  `,
  mr12: css`
    margin-right: 12px;
  `,
  mr16: css`
    margin-right: 16px;
  `,
  mr24: css`
    margin-right: 24px;
  `,
  mt2: css`
    margin-top: 2px;
  `,
  mt4: css`
    margin-top: 4px;
  `,
  mt8: css`
    margin-top: 8px;
  `,
  mt12: css`
    margin-top: 12px;
  `,
  mt16: css`
    margin-top: 16px;
  `,
  mt24: css`
    margin-top: 24px;
  `,
  mt32: css`
    margin-top: 32px;
  `,
  mt40: css`
    margin-top: 40px;
  `,
  mt48: css`
    margin-top: 48px;
  `,
  mv16: css`
    margin-top: 16px;
    margin-bottom: 16px;
  `,
  mv24: css`
    margin-top: 24px;
    margin-bottom: 24px;
  `,
  mv32: css`
    margin-top: 32px;
    margin-bottom: 32px;
  `,
  mv40: css`
    margin-top: 40px;
    margin-bottom: 40px;
  `,
  p0: css`
    padding: 0px;
  `,
  p16: css`
    padding: 16px;
  `,
  p24: css`
    padding: 24px;
  `,
  p40: css`
    padding: 40px;
  `,
  ph24: css`
    padding-left: 24px;
    padding-right: 24px;
  `,
  pv32: css`
    padding-top: 32px;
    padding-bottom: 32px;
  `,
  row: css`
    display: flex;
    flex-direction: row;
  `,
  rowAC: css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  rowACJC: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  `,
  rowACJB: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `,
  h100: css`
    height: 100%;
  `,
  w100: css`
    width: 100%;
  `,
};

export const TextStyle = {
  textCenter: css`
    text-align: center;
  `,
};
